import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import ProductAction from "../stores/actions/ProductAction";
import { RootState } from "../stores";
import { number } from "yup";
import { log } from "console";

function BuyerListModel({ buyerModel, setBuyerModel, productId }: any) {
  const handleClose = () => setBuyerModel(false);
  const dispatch = useDispatch<any>();

  const { buyerDataList } = useSelector((state: RootState) => state.product);
  const buyerList = useCallback(async () => {
    try {
      await dispatch(ProductAction.getBuyerList({ productId: productId }));
    } catch (error) {
      toast.error("Error Occurred in fetching data");
    }
  }, [dispatch, productId]);

  useEffect(() => {
    buyerList();
  }, [buyerList, productId]);

  console.log(buyerDataList);

  const onSubmitHandler = async (user_id: number) => {
    await dispatch(
      ProductAction.mapProduct({
        product_id: productId,
        user_id: user_id,
      })
    );
    buyerList();
  };

  return (
    <>
      <div className="modal" style={{ display: buyerModel ? "block" : "none" }}>
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <form className="needs-validation">
              <div className="modal-header">
                <h5 className="modal-title"></h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={handleClose}></button>
              </div>
              <div className="modal-body">
                <ul className="list-group list-group-flush">
                  {buyerDataList &&
                    buyerDataList.map((buyer: any, index: number) => {
                      console.log({ buyer });

                      return (
                        <li
                          key={index}
                          className="list-group-item"
                          style={{ fontSize: 16 }}>
                          <input
                            onChange={() => onSubmitHandler(buyer.id)}
                            type="checkbox"
                            id={productId}
                            checked={buyer.check}
                            className="form-check-input"
                            style={{
                              border: "1px solid #f68325",
                            }}></input>{" "}
                          <span>
                            {buyer.name_of_entity} - ( {buyer.account_id} )
                          </span>
                        </li>
                      );
                    })}
                </ul>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}

export default BuyerListModel;
